import axios from 'axios';
import { get } from './fetch.base.url';

const timeout = 8000;

class HttpRequest {
  constructor(baseUrl) {
    // 如果没有提供baseUrl，每次创建实例时重新获取
    this.baseUrl = baseUrl || get().manageUrl;
  }

  request(options) {
    const instance = axios.create({
      timeout: timeout,
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
        'Content-Type': 'application/json',
      }
    });

    options = this.mergeConfig(options);
    this.interceptors(instance, options.url);
    return instance(options);
  }

  interceptors(instance, url) {
    instance.interceptors.request.use(
      (config) => {
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    instance.interceptors.response.use(
      (res) => {
        const { data } = res;
        const { code, msg } = data;
        
        if (code !== 200) {
          // 使用Element UI的message组件进行错误提示
          import('element-ui').then(({ Message }) => {
            Message.error(msg);
          });
          
          if (code === 100003) {
            localStorage.removeItem("userAccount");
            localStorage.removeItem("token");
            window.location.href = '/login';
          }
        }
        
        return data;
      },
      (error) => {
        // 使用Element UI的message组件进行错误提示
        import('element-ui').then(({ Message }) => {
          Message.error(error.message || '请求失败');
        });
        return Promise.reject(error);
      }
    );
  }

  mergeConfig(options) {
    return Object.assign({ baseURL: this.baseUrl }, options);
  }
}

export default HttpRequest;
